import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import Card from "../../UI/Card/Card";
import * as DocumentationConstant from "../../Constants/DocumentationConstant";
import * as DocumentationActions from "../../../middleware/Store/Actions/DocumentationActions"

import LogService from "../../../middleware/CommonSdk/LogService";
const LOG_TAG = "SETTINGS-DOCUMENTATION";

const Documentation = (props) => {
    const intl = useIntl();

    const onFilterChanged = (event) => {
        LogService.info(LOG_TAG, "Change documentation filter:", event.target.value);
        props.setDocumentationFilter(event.target.value);
    };

    LogService.trace(LOG_TAG, "render");

    return (

        <Card id="option-doc" title={intl.messages.settingsDocTitle}>
            <div className="form-group">
                <select id="selectFilter" className="form-control mb-1"
                    value={props.documentationFilter}
                    onChange={onFilterChanged}
                >
                    <option value={DocumentationConstant.DocumentationType.Lts}>LTS</option>
                    <option value={DocumentationConstant.DocumentationType.Sts}>STS/LTS Beta</option>
                </select>
            </div>

            <div className="panel bg-fog mb-3">
                {intl.messages.settingsDocMessage}
            </div>
        </Card>
    )

}

const mapStateToProps = state => {
    return {
        documentationFilter: state.documentation.filter
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setDocumentationFilter: (value) => dispatch(DocumentationActions.setDocumentationFilter(value)),
        clearDocumentationFilter: () => dispatch(DocumentationActions.clearDocumentationFilter())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documentation);